import { cx } from 'cva';
import { type FunctionComponent } from 'react';
import { Toaster as Sonner, type ToasterProps as SonnerProps } from 'sonner';
import styles from './Toaster.module.css';

export type ToasterProps = SonnerProps & {
  className?: string;
};

export const Toaster: FunctionComponent<ToasterProps> = ({
  className,
  ...props
}: ToasterProps) => {
  return <Sonner className={cx(styles.root, className)} {...props} />;
};
